// ======================================================================
// File Name       : index
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import moment from 'moment';
import queryString from 'query-string';
import React from 'react';
import {
  CONFIG_FILE_STATUS, DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_FORMAT_DETAIL, DEFAULT_DATE_FORMAT_SERVER, DEFAULT_DATE_FROM_TEXT,
  DEFAULT_DATE_TO_TEXT, DORMANT_STATE, LO_SUPER_USER, MESSAGE_TYPE, SUPER_USER, USAGE_SETTING
} from '../constants';
import { SHOW_MESSAGE } from '../constants/actionTypes/message';
import * as MessageTemplate from '../constants/MessageTemplate';
import { USER_TYPE } from '../constants/UserConstants';
import store from '../store';
import * as ValidateUtils from '../utils/ValidateUtils';
import { downLoadImportFile } from './ApiUtils';

export const MIN_DATE = moment('1111/01/01');
export const MAX_DATE = moment('9999/12/31');
export const TODAY = moment().startOf('minutes');
export const LIVE_START_MIN_DATE = TODAY;
export const PRECENT_DAY = moment().endOf('date').format(DEFAULT_DATE_FORMAT);
export const YESTERDAY = moment().subtract(1, 'days').endOf('date');
export const TOMORROW = moment().add(1, 'days').endOf('date');
// #7062 START
export const DATE_INCLUDE_TODAY = moment().add(1, 'days').endOf('date').format(DEFAULT_DATE_FORMAT);
// #7062 END
// 5854: show the previous six month.
export const THE_PREVIOUS_SIX_MONTH = moment().subtract(6, 'months').endOf('date').format(DEFAULT_DATE_FORMAT);
export const MIN_MAX_DATE_TXT = '期限なし';
export const WRONG_CREATE_DATE_TXT = '終了日時は開始日時以降の日付を設定してください';
export const WRONG_DISTRIBUTION_DATE_TXT = ' 配布終了日時は配布開始日時よりも後の日時を入力してください';
export const WRONG_ATTENDING_DATE_TXT = '終了日時は開始日時以降の日付を設定してください';
export const WRONG_REPORT_DATE = '結果返却日は提出期限以降の日付を設定してください';
export const WRONG_MIN_RETURN_DATE = '結果返却日は当日よりも後の日時を入力してください';
export const WRONG_MIN_REPORT_DATE = 'レポート提出期限は当日よりも後の日時を入力してください';
export const WRONG_SIX_MONTH_PERIOD_TXT = '最大検索期間を超えています。日付の範囲を再設定してください';
export function downloadFile(url) {
  const link = document.createElement('a');
  if (url) {
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
// #7230 START
export const MIN_DATE_NO_SECOND = moment('1111/01/01 00:00');
export const MAX_DATE_NO_SECOND = moment('9999/12/31 23:59');
// #7230 END
/**
 *
 * @param selectName (the name of selectbox)
 * @param val (value of item in selectbox)
 * @return name corresponding value of the selectbox item
 */
export function getItemBoxName(dataList, val) {
  const name = dataList.map((item) => {
    let itemName = '';
    if (parseInt(item.value, 10) === parseInt(val, 10)) {
      itemName = item.name;
    }
    return itemName;
  });
  return name;
}

export function getDisplayName(dataList, value) {
  if (!dataList && !dataList.length){
    return '';
  }
  let displayName = '';
  dataList.forEach((item) => {
    if (item.value === value) {
      displayName = item.name;
    }
  });  
  return displayName;
}

export function getSettingUsageLabel(value) {
  return value === USAGE_SETTING.USE ? '利用あり' : '利用なし';
}

export function getDormantStateLabel(value) {
  return value === DORMANT_STATE.ACTIVE ? '稼働中' : '休止中';
}

/**
 * Open new window with url
 * @param url
 */
export function openNewWindow(url) {
  const rootUrl = '../../html/';
  const w = window.screen.width / 2;
  const h = window.screen.height / 2;
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  return window.open(
    rootUrl + url,
    'GuideLine',
    `width=${w}, height=${h}, top=${top}, left=${left}`,
  );
}

/**
 * Parse query param from props
 * @param {Object} props
 */
export function getQueryParam(location) {
  return location ? queryString.parse(location.search) : {};
}

export function shouldHideBackBtn(location) {
  if (location) {
    const queryParam = queryString.parse(location.search);
    if (queryParam && queryParam.hideBackOnDetail) {
      if (queryParam.hideBackOnDetail === true || queryParam.hideBackOnDetail === 'true') {
        return true;
      }
    }
  }
  return false;
}

/**
 * Convert number of second to time format
 * @param number
 */
export function convertNumberToTimeFormat(number) {
  if (number) {
    const hour = parseInt(number / 3600, 10);
    const minute = parseInt(number % 3600 / 60, 10);
    const second = parseInt(number % 3600 % 60, 10);
    const hourString = hour > 9 ? hour : `0${hour}`;
    const minuteString = minute > 9 ? minute : `0${minute}`;
    const secondString = second > 9 ? second : `0${second}`;
    return `${hourString}:${minuteString}:${secondString}`;
  }
  return '00:00:00';
}

export function hasProperty(obj, fieldName) {
  if (!obj || !fieldName) return false;
  return Object.prototype.hasOwnProperty.call(obj, fieldName);
}

export function displayUserAuthority({ userType, managementAuthoritySecernId }, authority) {
  if (managementAuthoritySecernId) {
    if (authority
      && authority.bySecernId
      && authority.bySecernId[managementAuthoritySecernId]) {
      return authority.bySecernId[managementAuthoritySecernId].managementAuthorityName;
    }
  }

  switch (userType) {
    case USER_TYPE.STUDENT:
      return '受講ユーザー';

    case USER_TYPE.GUARDIAN:
      return '履歴閲覧ユーザー';

    default:
      return '';
  }
}

export function randomArray(array, arrayNum) {
  let selected = [];
  if (array && array.length < arrayNum) {
    return selected;
  }
  for (let i = 0; i < arrayNum; i++) {
    selected = rand(array, selected);
  }
  return selected;
}

function rand(array, selected) {
  const ran = array[Math.floor(Math.random() * array.length)];
  if (selected.indexOf(ran) === -1) {
    selected.push(ran);
  } else {
    rand(array, selected);
  }
  return selected;
}

export function handleCalendarIconClick(event) {
  if (event && event.target) {
    const target = $(event.target).parent().parent();
    if (target && target.length) {
      const input = target.find('input');
      if (input && input.length) {
        input.click();
      }
    }
  }
}

function checkDate(date, compareText) {
  if (!date || date === compareText) {
    return true;
  }
  if (date && (moment(date).startOf('day').isSameOrBefore(MIN_DATE) ||
  moment(date).startOf('day').isSameOrAfter(MAX_DATE))) {
    return true;
  }
  return false;
}

export function handleDateTime(dateTimeFrom, dateTimeTo) {
  let dateTimeFromTxt = '';
  let dateTimeToTxt = '';
  try {
    if (checkDate(dateTimeFrom, MIN_MAX_DATE_TXT)) {
      dateTimeFromTxt = '';
    } else {
      dateTimeFromTxt = dateTimeFrom;
    }
    if (checkDate(dateTimeTo, MIN_MAX_DATE_TXT)) {
      dateTimeToTxt = '';
    } else {
      dateTimeToTxt = dateTimeTo;
    }
  } catch (error) {
    dateTimeFromTxt = dateTimeFrom;
    dateTimeToTxt = dateTimeTo;
  }
  return { dateTimeFromTxt, dateTimeToTxt };
}

export function handleReportDateTime(reportReturnPlanDate, reportDeadline, format) {
  let dateTimeFromTxt = '';
  let dateTimeToTxt = '';
  if (!format) {
    format = DEFAULT_DATE_FORMAT_SERVER;
  }
  try {
    if (checkDate(reportReturnPlanDate, DEFAULT_DATE_FROM_TEXT)) {
      dateTimeFromTxt = '';
    } else {
      dateTimeFromTxt = reportReturnPlanDate ? moment(reportReturnPlanDate).endOf('day').format(format) : '';
    }
    if (checkDate(reportDeadline, DEFAULT_DATE_TO_TEXT)) {
      dateTimeToTxt = '';
    } else {
      dateTimeToTxt = reportDeadline ? moment(reportDeadline).endOf('day').format(format) : '';
    }
  } catch (error) {
    dateTimeFromTxt = reportReturnPlanDate;
    dateTimeToTxt = reportDeadline;
  }
  return { dateTimeFromTxt, dateTimeToTxt };
}

export function handleReportDateTimeDetail(reportReturnPlanDate, reportDeadline, format) {
  let dateTimeFromTxt = '';
  let dateTimeToTxt = '';
  if (!format) {
    format = DEFAULT_DATE_FORMAT_SERVER;
  }
  try {
    if (checkDate(reportReturnPlanDate, DEFAULT_DATE_FROM_TEXT)) {
      dateTimeFromTxt = DEFAULT_DATE_FROM_TEXT;
    } else {
      dateTimeFromTxt = reportReturnPlanDate ? moment(reportReturnPlanDate).endOf('day').format(format) : '';
    }
    if (checkDate(reportDeadline, DEFAULT_DATE_TO_TEXT)) {
      dateTimeToTxt = DEFAULT_DATE_TO_TEXT;
    } else {
      dateTimeToTxt = reportDeadline ? moment(reportDeadline).endOf('day').format(format) : '';
    }
  } catch (error) {
    dateTimeFromTxt = reportReturnPlanDate;
    dateTimeToTxt = reportDeadline;
  }
  return { dateTimeFromTxt, dateTimeToTxt };
}

export function showExportCSVSuccessMessage() {
  const state = store.getState();
  const messageInfo = {
    message: [MessageTemplate.MSG_EXPORT_CSV_SUCCESS],
  };

  messageInfo.targetModal = !!state.modal.modalId;
  messageInfo.messageType = MESSAGE_TYPE.success;

  store.dispatch({ type: SHOW_MESSAGE, ...messageInfo });
}

export function showSuccessMessage(message) {
  const state = store.getState();
  const messageInfo = {
    message: [message],
  };

  messageInfo.targetModal = !!state.modal.modalId;
  messageInfo.messageType = MESSAGE_TYPE.success;

  store.dispatch({ type: SHOW_MESSAGE, ...messageInfo });
}

export function validateDateTime(date, format, minMaxDateTxt) {
  let isValid = true;
  if (date && date !== minMaxDateTxt) {
    try {
      if (date.isValid && date.isValid()) {
        isValid = true;
      } else {
        date = date.replace(/-/g, '/');
        isValid = moment(date, format).format(format) === date;
      }
    } catch (error) {
      isValid = false;
    }
  }
  return isValid;
}

export function parseDateForDetail(date, format, limitTxt) {
  if (!format) {
    format = DEFAULT_DATE_FORMAT_DETAIL;
  }
  if (!limitTxt) {
    limitTxt = '';
  }
  if (!date) return limitTxt;
  const mDate = moment(date).startOf('day');
  if (mDate.isSameOrBefore(MIN_DATE) || mDate.isSameOrAfter(MAX_DATE)) {
    return limitTxt;
  }
  return moment(date).format(format);
}

export function parseImportHistory(importErrorCount, importEndTime) {
  if (!importEndTime) {
    return '';
  }
  let text = 'タイムアウト';
  if (importErrorCount) {
    text = importErrorCount;
  }
  if (!isNaN(parseInt(importErrorCount, 10)) && importErrorCount == 0) {
    text = '成功';
  }
  return text;
}

export function parseDateForDetailDiv(date, format, limitTxt) {
  if (!format) {
    format = DEFAULT_DATE_FORMAT_DETAIL;
  }
  if (!limitTxt) {
    limitTxt = '';
  }
  if (!date) return limitTxt;
  const mDate = moment(date).startOf('day');
  if (mDate.isSameOrBefore(MIN_DATE) || mDate.isSameOrAfter(MAX_DATE)) {
    return limitTxt;
  }
  return (
    <div>
      <div>{moment(date).format('YYYY/MM/DD')}</div>
      <div>
        {moment(date).format('HH:mm:ss')}
      </div>
    </div>
  );
}

export function getDisplayPublicPeriod(publicDateFrom, publicDateTo) {
  const dateFromText = parseDateForDetail(publicDateFrom, 'YYYY/MM/DD', '');
  const dateToText = parseDateForDetail(publicDateTo, 'YYYY/MM/DD', '無期限');
  if (dateFromText === '' && dateToText === '無期限') {
    return '無期限';
  }
  return `${dateFromText} ～ ${dateToText}`;
}

export function compareDate(dateFrom, dateTo) {
  if (dateFrom && dateTo) {
    dateFrom = moment(dateFrom).startOf('day');
    dateTo = moment(dateTo).startOf('day');
    return dateFrom.isAfter(dateTo);
  }
  return false;
}

export function setCookie(key, value) {
  return async (dispatch) => {
    const index = window.location.hostname.indexOf('.');
    if (index > -1) {
      const domainName = window.location.hostname.slice(index);
      await global.cookies.set(key, value, { path: '/', domain: domainName });
    } else {
      await global.cookies.set(key, value, { path: '/', domain: window.location.hostname });
    }
    return {};
  };
}

export function isIE() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10) > 9;
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) > 9;
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10) > 9;
  }

  // other browser
  return false;
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
}

export function displayMinutes(minutes) {
  const minuteParse = parseInt(minutes, 10);
  const timeObj = {
    h: '',
    m: '',
  };
  if (!isNaN(minuteParse)) {
    let hours = Math.floor(minuteParse / 60);
    let mins = minutes - (hours * 60);
    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (mins < 10) {
      mins = `0${mins}`;
    }
    timeObj.h = hours;
    timeObj.m = mins;
  }
  return timeObj;
}

export function handleDownload(url, fileName) {
  return downLoadImportFile(url).then((blob) => {
    if (url) {
      const placeStart = url.lastIndexOf('/');
      const placeEnd = url.indexOf('?');
      const nameKey = url.slice(placeStart + 1, placeEnd);
      // IE10+ : (has Blob, but not a[download] or URL)
      if (window.navigator.msSaveOrOpenBlob) {
        const blobObject = new Blob([blob]);
        return window.navigator.msSaveOrOpenBlob(blobObject, nameKey);
      }
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = nameKey;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(() => {
        URL.revokeObjectURL(blob);
        document.body.removeChild(link);
      }, 10);
    }
    return {};
  });
}

export function isSuperUser(displayUserType) {
  return [LO_SUPER_USER, SUPER_USER].indexOf(displayUserType) > -1;
}

// Step 10.0.0 START
export function isSuperUserL1(displayUserType) {
  return [SUPER_USER].indexOf(displayUserType) > -1;
}

export function isSuperUserL0(displayUserType) {
  return [LO_SUPER_USER].indexOf(displayUserType) > -1;
}
// Step 10.0.0 END
export function escapeHtml(text) {
  return text
       .replace(/&/g, '&amp;')
       .replace(/</g, '&lt;')
       .replace(/>/g, '&gt;')
       .replace(/"/g, '&quot;')
       .replace(/'/g, '&#039;');
}

export function checkUserChecked(edittingUserList, userListOnDialog) {
  const userChecked = [];
  if (edittingUserList && Object.keys(edittingUserList) && Object.keys(edittingUserList).length) {
    Object.keys(edittingUserList).map((userSecernId) => {
      if (userSecernId && edittingUserList[userSecernId]) {
        userChecked.push(userSecernId);
      }
    });
  }
  if (edittingUserList && userListOnDialog) {
    const userCheckedOnPage = [];
    userListOnDialog.map((userList) => {
      const { userSecernId } = userList;
      const pos = userChecked.indexOf(userSecernId);
      if (pos > -1) {
        userCheckedOnPage.push(userSecernId);
      }
    });
    return userCheckedOnPage;
  }
  return userChecked;
}
export function htmlEntities(str, isReplaceBrTag = true) {
  str = isReplaceBrTag ? String(str).replace(/<br\s*\/?>/mg, '\n') : str;

  str = String(str)
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');

  return str;
}

export function convertStatusConfigFile(status) {
  switch (status) {
    case CONFIG_FILE_STATUS.PENDING:
      return '処理待ち';
    case CONFIG_FILE_STATUS.PROCESSING:
      return '処理中';
    case CONFIG_FILE_STATUS.PROCESSED:
      return '処理済';
    case CONFIG_FILE_STATUS.ERROR:
      return 'エラー';
    default:
      return '';
  }
}

export function replaceAllLineBreakWithHTMLTag(text, htmlTag) {
  text = String(text).replace(/(\u21b5|\r\n|\n|\r)/gm, htmlTag);
  return text;
}

// #7259 START
export const jaJPCustom = {
  today: '今日',
  now: '現在時刻',
  backToToday: '今日に戻る',
  ok: '決定',
  timeSelect: '時間を選択',
  dateSelect: '日付を選択',
  clear: 'クリア',
  month: '月',
  year: '年',
  previousMonth: '前月 (ページアップキー)',
  nextMonth: '翌月 (ページダウンキー)',
  monthSelect: '月を選択',
  yearSelect: '年を選択',
  decadeSelect: '年代を選択',
  yearFormat: 'YYYY年',
  dayFormat: 'D日',
  dateFormat: 'YYYY年M月D日',
  dateTimeFormat: 'YYYY年M月D日 HH時mm分ss秒',
  previousYear: '前年 (Controlを押しながら左キー)',
  nextYear: '翌年 (Controlを押しながら右キー)',
  previousDecade: '前の年代',
  nextDecade: '次の年代',
  previousCentury: '前の世紀',
  nextCentury: '次の世紀',
};
// #7259 END
// #7287 START
export function removeAllScriptExcludeBundleJS() {
  $('script').each((_index, value) => {
    if (!ValidateUtils.isBundleScript(value.src)) {
      $(value).remove();
    }
  });
}
// #7287 END

// #7222 START
export function doPromiseInSequence(promises) {
  return promises.reduce((p, task) => p.then(task), Promise.resolve());
}
// #7222 END

// Step 7.0 #3 START
export function downloadThumbnail(imageUrl) {
  const tmpName = imageUrl.replace(/^.*[\\\/]/, '');
  const fileName = tmpName.substr(0, tmpName.indexOf('?'));
  handleDownload(imageUrl,fileName);
}
// Step 7.0 #3 END

// sprint_20230403 #4 START
export function getSettingUsageBooleanLabel(value) {
  return value ? '利用あり' : '利用なし';
}

export function getStatusDisplayLabel(value) {
  return value ? '表示あり' : '表示なし';
}
// sprint_20230403 #4 END

// sprint_20230508 #27 START
export function getDormantUserDataAcquisitionPermissionFlag(value) {
  return value ? '許可する' : '許可しない';
}
// sprint_20230508 #27 END

// Step12.0.0 sprint44 START
export function getBackgroundVideoPlaybackFlagLabel(value) {
  return value ? 'バックグラウンド再生許可' : 'バックグラウンド再生停止';
}
// Step12.0.0 sprint44 END